import React from 'react';
import {
  Box,
  SkeletonGroup,
  SkeletonRectangle,
  SkeletonLine,
} from '@wix/design-system';
import s from '../TemplateCard.module.scss';

export interface TemplateLoadingCardProps {
  componentHeight?: string;
  skeletonHeight?: string;
  noBackground?: boolean;
}

const TemplateLoadingCard = React.forwardRef<
  HTMLDivElement,
  TemplateLoadingCardProps
>(({ componentHeight = '322px', skeletonHeight, noBackground }, ref) => {
  return (
    <SkeletonGroup skin="light">
      <Box
        className={noBackground ? s.noBackgroundTemplate : s.template}
        direction="vertical"
        minWidth="218px"
        height={componentHeight}
        padding={noBackground ? '0px' : '12px'}
        overflow="hidden"
        borderRadius="4px"
      >
        <div ref={ref} />
        <div className={skeletonHeight ? '' : s.skeletonRectStyle}>
          <SkeletonRectangle height={skeletonHeight} />
        </div>
        <Box direction="horizontal" width="100%" align="space-between">
          <SkeletonLine width="132px" marginTop="12px" />

          <div className={s.skeletonLineStyle}>
            <SkeletonLine width="32px" marginTop="12px" />
          </div>
        </Box>
        <SkeletonLine width="132px" marginTop="4px" />
        <SkeletonLine width="46px" marginTop="36px" />
      </Box>
    </SkeletonGroup>
  );
});

export default TemplateLoadingCard;
